import React, { useState, useEffect } from "react";
import Modal from "../Modal/Modal";
import Select from "../../Formik/Select/Select";
import Button from "../../Button/Button";
import { useDispatch } from "react-redux";
import styles from "./DepositModal.module.scss";
import {
  generateAccountAction,
  getUserCoinListAction,
} from "../../../../features/user/userSlice";
import { STATUS_CODE } from "../../../../utils/constants";

const DepositModal = ({ show, handleClose }) => {
  const dispatch = useDispatch();
  const [selectedCoin, setSelectedCoin] = useState(null);
  const [selectedNetwork, setSelectedNetwork] = useState(null);
  const [networkOptions, setNetworkOptions] = useState([]);
  const [generatedAddress, setGeneratedAddress] = useState("");
  const [addressLoading, setAddressLoading] = useState(false);
  const [coinOptions, setCoinOptions] = useState([]);

  // const fetchCoinOptions = async () => {
  //   try {
  //     const response = await dispatch(getUserCoinListAction());
  //     if (response.data.status === STATUS_CODE.successful) {
  //       const array = [];

  //       const newData = response.data.data.coinList;
  //       newData?.map((coin) => {
  //         array.push({
  //           value: coin.id,
  //           label: coin.coin_symbol,
  //           networkdetails: coin.networkDetail,
  //           image: coin.image_path,
  //         });
  //       });
  //       setCoinOptions(array);

  //       // Set default coin and network
  //       const defaultCoin = array.find((coin) => coin.label === "ETH");
  //       if (defaultCoin) {
  //         setSelectedCoin(defaultCoin);
  //         const defaultNetwork = defaultCoin.networkdetails[0];
  //         setSelectedNetwork({
  //           value: defaultNetwork.id,
  //           label: defaultNetwork.parent_coin_name,
  //         });
  //         setNetworkOptions(
  //           defaultCoin.networkdetails.map((network) => ({
  //             value: network.id,
  //             label: network.parent_coin_name,
  //           }))
  //         );
  //         generateAddress(defaultCoin.label, defaultNetwork.parent_coin_name);
  //       }
  //     }
  //   } catch (error) {
  //     console.error("Error fetching coin options:", error);
  //   }
  // };

  const fetchCoinOptions = async () => {
    try {
      const response = await dispatch(getUserCoinListAction());
      if (response.data.status === STATUS_CODE.successful) {
        const array = [];
        const newData = response.data.data.coinList;
        newData?.map((coin) => {
          array.push({
            value: coin.id,
            label: coin.coin_symbol,
            networkdetails: coin.networkDetail,
            image: coin.image_path,
          });
        });
        setCoinOptions(array);

        // Set default coin and network
        if (array.length > 0) {
          const defaultCoin = array[0]; // Set default to the first coin in the list
          setSelectedCoin(defaultCoin);
          const defaultNetwork = defaultCoin.networkdetails[0];
          setSelectedNetwork({
            value: defaultNetwork.id,
            label: defaultNetwork.parent_coin_name,
          });
          setNetworkOptions(
            defaultCoin.networkdetails.map((network) => ({
              value: network.id,
              label: network.parent_coin_name,
            }))
          );
          generateAddress(defaultCoin.label, defaultNetwork.parent_coin_name);
        }
      }
    } catch (error) {
      console.error("Error fetching coin options:", error);
    }
  };

  useEffect(() => {
    fetchCoinOptions();
  }, []);

  useEffect(() => {
    if (show) {
      generateAddress(selectedCoin?.label, selectedNetwork?.label);
    }
  }, [show]);

  const handleCoinChange = (selectedCoin) => {
    setSelectedCoin(selectedCoin);

    const newDetails = selectedCoin?.networkdetails;
    const networks = newDetails.map((network) => ({
      value: network.id,
      label: network.parent_coin_name,
    }));

    setNetworkOptions(networks);
    setSelectedNetwork(networks[0]); 
    setGeneratedAddress(""); 
    generateAddress(selectedCoin.label, networks[0].label); 
  };




  const handleNetworkChange = (selectedNetwork) => {
    setSelectedNetwork(selectedNetwork);
    setGeneratedAddress(""); 
    generateAddress(selectedCoin?.label, selectedNetwork.label); 
  };

  const generateAddress = async (coinLabel, networkLabel) => {
    if (!coinLabel || !networkLabel) {
      return;
    }

    setAddressLoading(true);

    try {
      const response = await dispatch(
        generateAccountAction({
          coin: coinLabel,
          netWork: networkLabel,
        })
      );

      if (response.data.status === STATUS_CODE.successful) {
        const address = response.data.data;
        setGeneratedAddress(address);
      }
    } catch (error) {
      console.error("Error generating address:", error);
    } finally {
      setAddressLoading(false);
    }
  };

  return (
    <Modal show={show} handleClose={handleClose} title="Deposit">
      <div className={`d-flex justify-content-between`}>
        <div className="mb-4">
          {coinOptions.length > 0 && (
            <Select
              options={coinOptions}
              value={selectedCoin}
              placeholder="Select Coin"
              variant="dark large_height"
              isSearchable={false}
              onChange={handleCoinChange}
            />
          )}
        </div>
        <div className={`${styles.buy_module_asset} ${styles.mb_16}`}>
          <Select
            options={networkOptions}
            value={selectedNetwork} 
            onChange={(e) => handleNetworkChange(e)}
            placeholder="Select Network"
            isDisabled={!selectedCoin}
            variant="dark large_height"
          />
        </div>
      </div>

      {addressLoading ? (
        <p>Loading address...</p>
      ) : (
        generatedAddress && (
          <>
            <img src={generatedAddress.qrCode} alt="logo" />
            <p>Generated Address: {generatedAddress.address}</p>
          </>
        )
      )}
    </Modal>
  );
};

export default DepositModal;
